import {Component, EventEmitter, Inject, Input, OnInit, Output} from '@angular/core';
import {L10N_LOCALE, L10nLocale} from 'angular-l10n';

@Component({
  selector: 'storever-action-button',
  templateUrl: './action-button.component.html',
  styleUrls: ['./action-button.component.scss']
})
export class ActionButtonComponent implements OnInit {
  @Input() buttonTitle: string;
  @Input() buttonIcon: string;
  // tslint:disable-next-line:no-any
  @Output() actions = new EventEmitter<any>();
  constructor(@Inject(L10N_LOCALE) public locale: L10nLocale) {
  }

  ngOnInit(): void {
  }

  actionsEmit(): void {
    this.actions.emit();
  }


}
